export class W3AccordionGroup {
  accordionButtons: NodeListOf<Element> | null;
  accordionContents: NodeListOf<Element> | null;

  constructor() {
    this.accordionButtons = document.querySelectorAll(
      ".accordion-item__button--js",
    );
    this.accordionContents = document.querySelectorAll(
      ".accordion-item__content",
    );
    const needToOpenFirstAccordion = document.querySelector(
      ".accordion-group--first-open",
    );
    if (needToOpenFirstAccordion) {
      this.openFirstAccordion();
    }

    this.registerEventHandlers();
  }

  /**
   * registerEventHandlers - Register event handlers for the accordion group component
   */
  private registerEventHandlers(): void {
    if (!this.accordionButtons || !this.accordionContents) return;
    this.accordionButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        let currentButton = event.target as HTMLElement;
        if (event.target instanceof HTMLSpanElement) {
          currentButton = event.target.parentElement as HTMLElement;
        }
        const isActive = currentButton.classList.contains("active");

        this.closeAllAccordions();

        if (!isActive) {
          currentButton.classList.add("active");

          const panel = currentButton.nextElementSibling;
          if (panel) {
            panel.classList.add("active");
          }
        }
      });
    });
  }

  /**
   * closeAllAccordions - Close all accordion panels by removing the active class
   */
  private closeAllAccordions(): void {
    if (!this.accordionButtons || !this.accordionContents) return;

    this.accordionButtons.forEach((button) => {
      button.classList.remove("active");
      const panel = button.nextElementSibling;

      if (panel && panel.classList.contains("active")) {
        panel.classList.remove("active");
      }
    });
  }

  /**
   * openFirstAccordion - Open the first accordion panel
   */
  private openFirstAccordion(): void {
    const firstAccordionButton = document.querySelector(
      ".accordion-item__button--js",
    );
    const firstContent = document.querySelector(".accordion-item__content");
    if (firstAccordionButton && firstContent) {
      firstAccordionButton.classList.add("active");
      firstContent.classList.add("active");
    }
  }
}
